var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{staticClass:"text-left",attrs:{"show":_vm.dismissCountDown,"variant":_vm.variant,"dismissible":""},on:{"dismissed":function($event){_vm.dismissCountDown = 0},"dismiss-count-down":_vm.countDownChanged}},[_c('p',{staticClass:"m-0",domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }